module.exports = __webpack_public_path__ + "static/img/WisdomSiteZhihui.5c27fd9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WisdomSite/WisdomSiteZhihui.png
// module id = zCLx
// module chunks = 12